import { http, HttpResponse } from 'msw';
import { DEMO_BACKTESTS } from '../demo-fixtures';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demoBacktestsHandlers = [
  // ── List backtests ────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/backtests`, () => {
    const items = DEMO_BACKTESTS.map(({ equity_curve: _, ...b }) => b);
    return HttpResponse.json({
      items,
      total: items.length,
      limit: 50,
      offset: 0,
    });
  }),

  // ── Get backtest detail ───────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/backtests/:id`, ({ params }) => {
    const id = Number(params['id']);
    const bt = DEMO_BACKTESTS.find((b) => b.id === id);
    if (!bt) return HttpResponse.json({ detail: 'Not found' }, { status: 404 });
    return HttpResponse.json(bt);
  }),

  // ── Get backtest equity curve ─────────────────────────────────────────────
  http.get(`${BASE}/api/v1/backtests/:id/equity-curve`, ({ params }) => {
    const id = Number(params['id']);
    const bt = DEMO_BACKTESTS.find((b) => b.id === id);
    return HttpResponse.json({
      backtest_run_id: id,
      points: bt?.equity_curve ?? [],
    });
  }),

  // ── Compare backtests ────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/backtests/compare`, ({ request }) => {
    const url = new URL(request.url);
    const idsParam = url.searchParams.get('ids') ?? '';
    const ids = idsParam.split(',').map(Number).filter(Boolean);
    const runs = ids.map((id) => DEMO_BACKTESTS.find((b) => b.id === id)).filter(Boolean);
    return HttpResponse.json({ runs });
  }),

  // ── Run new backtest ──────────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/backtests`, async ({ request }) => {
    const body = (await request.json()) as Record<string, unknown>;
    const newRun = {
      id: 99,
      user_id: 42,
      ...body,
      status: 'COMPLETED',
      final_equity: '10847.30',
      total_return_pct: '8.47',
      total_trades: 42,
      winning_trades: 26,
      losing_trades: 16,
      win_rate: '61.90',
      sharpe_ratio: '1.12',
      max_drawdown_pct: '6.84',
      avg_trade_pnl: '20.17',
      created_at: new Date().toISOString(),
      completed_at: new Date(Date.now() + 2000).toISOString(),
    };
    return HttpResponse.json(newRun, { status: 201 });
  }),

  // ── Delete backtest ───────────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/backtests/:id`, () => {
    return new HttpResponse(null, { status: 204 });
  }),
];
